import { zodParse } from '../../../utils';
import useSWR from 'swr';
import { BASE_URL } from '..';
import { Identity, Z_Identity } from './types';

export const useIdentity = () =>
  useSWR('/api/v4/identity', async () => {
    const response = await fetch(`${BASE_URL}/identity/`);
    const json: Identity = await response.json();
    zodParse(Z_Identity, json, 'Identity');
    return json;
  });
